"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChangeEmailLessFormSubmissionSettingRequestStatus = exports.getUnsubscribeLeadSyncingEntityRequestStatus = exports.getSelectLeadSyncingEntitiesRequestStatus = exports.getFetchSelectedLeadSyncingEntitiesRequestStatus = exports.getFetchAvailableLeadSyncingEntitiesRequestStatus = exports.getSetAdAccountTrackingRequestStatus = exports.getDeleteUserAuthRequestStatus = exports.getDeleteAdAccountRequestStatus = exports.getDeleteFacebookAdAccountRequestStatus = exports.getFetchConnectedUsersRequestStatus = exports.getFetchAdAccountsRequestStatus = exports.getAllowEmailLessFormSubmissions = exports.getAvailableLeadSyncingEntities = exports.getSelectedLeadSyncingEntities = exports.getConnectedUsers = exports.getAdAccounts = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getAdAccounts = function getAdAccounts(state) {
  return state.modules.marketing.ads.entities.accounts.get('adAccounts');
};

exports.getAdAccounts = getAdAccounts;

var getConnectedUsers = function getConnectedUsers(state) {
  return state.modules.marketing.ads.entities.accounts.get('connectedUsers');
};

exports.getConnectedUsers = getConnectedUsers;

var getSelectedLeadSyncingEntities = function getSelectedLeadSyncingEntities(state) {
  return state.modules.marketing.ads.entities.accounts.get('selectedLeadSyncingEntities');
};

exports.getSelectedLeadSyncingEntities = getSelectedLeadSyncingEntities;

var getAvailableLeadSyncingEntities = function getAvailableLeadSyncingEntities(state) {
  return state.modules.marketing.ads.entities.accounts.get('availableLeadSyncingEntities');
};

exports.getAvailableLeadSyncingEntities = getAvailableLeadSyncingEntities;

var getAllowEmailLessFormSubmissions = function getAllowEmailLessFormSubmissions(state) {
  return state.modules.marketing.ads.entities.accounts.get('allowEmailLessFormSubmissions');
};

exports.getAllowEmailLessFormSubmissions = getAllowEmailLessFormSubmissions;
var getFetchAdAccountsRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.FETCH_AD_ACCOUNTS);
exports.getFetchAdAccountsRequestStatus = getFetchAdAccountsRequestStatus;
var getFetchConnectedUsersRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.FETCH_CONNECTED_USERS);
exports.getFetchConnectedUsersRequestStatus = getFetchConnectedUsersRequestStatus;
var getDeleteFacebookAdAccountRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.DELETE_FACEBOOK_AD_ACCOUNT);
exports.getDeleteFacebookAdAccountRequestStatus = getDeleteFacebookAdAccountRequestStatus;
var getDeleteAdAccountRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.DELETE_AD_ACCOUNT);
exports.getDeleteAdAccountRequestStatus = getDeleteAdAccountRequestStatus;
var getDeleteUserAuthRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.DELETE_USER_AUTH);
exports.getDeleteUserAuthRequestStatus = getDeleteUserAuthRequestStatus;
var getSetAdAccountTrackingRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.SET_AD_ACCOUNT_TRACKING);
exports.getSetAdAccountTrackingRequestStatus = getSetAdAccountTrackingRequestStatus;
var getFetchAvailableLeadSyncingEntitiesRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.FETCH_AVAILABLE_LEAD_SYNCING_ENTITIES);
exports.getFetchAvailableLeadSyncingEntitiesRequestStatus = getFetchAvailableLeadSyncingEntitiesRequestStatus;
var getFetchSelectedLeadSyncingEntitiesRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.FETCH_SELECTED_LEAD_SYNCING_ENTITIES);
exports.getFetchSelectedLeadSyncingEntitiesRequestStatus = getFetchSelectedLeadSyncingEntitiesRequestStatus;
var getSelectLeadSyncingEntitiesRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.SELECT_LEAD_SYNCING_ENTITIES);
exports.getSelectLeadSyncingEntitiesRequestStatus = getSelectLeadSyncingEntitiesRequestStatus;
var getUnsubscribeLeadSyncingEntityRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.UNSUBSCRIBE_LEAD_SYNCING_ENTITY);
exports.getUnsubscribeLeadSyncingEntityRequestStatus = getUnsubscribeLeadSyncingEntityRequestStatus;
var getChangeEmailLessFormSubmissionSettingRequestStatus = (0, _getRequestStatus.default)(_actions.AccountsActionTypes.CHANGE_EMAIL_LESS_FORM_SUBMISSIONS_SETTING);
exports.getChangeEmailLessFormSubmissionSettingRequestStatus = getChangeEmailLessFormSubmissionSettingRequestStatus;